import React, {memo} from 'react';
import Container from '@/components/atoms/Container';
import OptimizedImage from '@/components/atoms/OptimizedImage';
import styles from './HomePartnership.module.scss';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const HomePartnership = (props: any) => {
    const {heading, subheading, contentData} = props;
    return (
        <div>
            <Container>
                <div className={styles.header}>
                    <h2 className={`font-headers ${styles.heading}`}>{heading}</h2>
                    <p className={styles.subheading}>{subheading}</p>
                </div>
                <div>
                    <div className={styles.grid}>
                        {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
                        {contentData?.map((item: any, index: number) => (
                            <div key={index + 1} className={styles.item}>
                                <div className={styles.card}>
                                    <div className={styles.logo}>
                                        <OptimizedImage alt={item.heading} src={item.src} fill style={{objectFit: 'contain'}} />
                                    </div>
                                    <p className={`font-regular-text ${styles.label}`}>{item.heading}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </Container>
        </div>
    );
};

export default memo(HomePartnership);
